module.exports = [{
      plugin: require('/Users/tiffanytse/src/github.com/Shopify/liquid-code-examples/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/tiffanytse/src/github.com/Shopify/liquid-code-examples/node_modules/gatsby-plugin-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-49178120-51","head":false,"anonymize":true},
    },{
      plugin: require('/Users/tiffanytse/src/github.com/Shopify/liquid-code-examples/node_modules/gatsby-plugin-emotion/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/tiffanytse/src/github.com/Shopify/liquid-code-examples/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
